import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { GetListRead, Delete } from "../lib/Push";
import moment from "moment";
import PageBar from "../components/pagebar";

const pushImage = {
    HEART: "heart",
    RESP: "breath",
    FSR: "oxygen",
    HEARTE: "heart_dise",
    RESPE: "breath_dise",
    SLEEP: "sleep_dise"
};

const Emergency = () => {
    const { t } = useTranslation();

    const [items, setItems] = useState([]);
    const [range, setRange] = useState({ size: 10, start: 0, end: 29, total: 0 });
    const [data, setData] = useState({
        page: 1,
        size: "10",
        sort: "-push_read_no"
    });

    useEffect(() => {
        GetListRead(data, res => {
            setItems(res.rows);
            setRange(res.range);
        });
    }, [data]);

    const clickDelete = () => {
        const ids = items.filter(x => x.checked).map(x => x.push_no);

        if (ids.length > 0) {
            if (window.confirm(t("삭제 하시겠습니까?"))) {
                Delete({ ids }, res => {
                    setData({ ...data });
                });
            }
        }
    };

    return (
        <main className="sub-contents">
            <section className="sub-top-section"></section>

            <div className="inner">
                <h2 className="sub_title">{t("긴급 알림")}</h2>
                <h3 className="sub_title_sm">Emergency</h3>

                <section className="emergency_alarm_cate_wrapper">
                    <dl>
                        <dt>{t("이상 생체 정보 알람")}</dt>
                        <dd>
                            <div className="box">
                                <span className="icons circle heart"></span>
                                <span className="txt">{t("심박수")}</span>
                            </div>
                            <div className="box">
                                <span className="icons circle breath"></span>
                                <span className="txt">{t("호흡수")}</span>
                            </div>
                            <div className="box">
                                <span className="icons circle oxygen"></span>
                                <span className="txt">{t("FRS")}</span>
                            </div>
                        </dd>
                    </dl>
                    {/* <dl>
                        <dt>{t("질환 의심 경고 알람")}</dt>
                        <dd>
                            <div className="box">
                                <span className="icons circle heart_dise"></span>
                                <span className="txt">{t("심장 질환")}</span>
                            </div>
                            <div className="box">
                                <span className="icons circle breath_dise"></span>
                                <span className="txt">{t("호흡 질환")}</span>
                            </div>
                            <div className="box">
                                <span className="icons circle sleep_dise"></span>
                                <span className="txt">{t("수면질환")}</span>
                            </div>
                        </dd>
                    </dl> */}
                </section>

                <section className="emergency_list_wrapper">
                    <div className="tops">
                        <h3>{t("긴급 알람 이력")}</h3>
                        <button type="button" className="btn_nor md line" onClick={clickDelete}>
                            {t("삭제")}
                        </button>
                    </div>

                    <div className="table_box">
                        <table className="tbl_emergency">
                            <caption>{t("긴급 알람 이력")}</caption>
                            <colgroup>
                                <col width="5%" />
                                <col width="8%" />
                                <col width="10%" />
                                <col width="auto" />
                                <col width="20%" />
                            </colgroup>
                            <tbody>
                                {items.map(x => {
                                    return (
                                        <tr>
                                            <td className="ch">
                                                <input
                                                    type="checkbox"
                                                    onClick={() => {
                                                        x.checked = !x.checked;
                                                        setItems([...items]);
                                                    }}
                                                    checked={x.checked}
                                                />
                                            </td>
                                            <td className="icon">
                                                <span className={`icons circle ${pushImage[x.type]}`}></span>
                                            </td>
                                            <td className="cate">
                                                <p className="sbj">{t(x.title)}</p>
                                            </td>
                                            <td className="cont">{t(x.message)}</td>
                                            <td className="date">{moment(x.time).format("YYYY. MM. DD")}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>

            <PageBar
                nowPage={Number(data.page)}
                totalPage={Math.ceil(Number(range.total) / Number(range.size))}
                reload={page => {
                    data.page = page;
                    setData({ ...data });
                }}
            />
        </main>
    );
};

export default Emergency;
